<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19cQaKo/tc-custom/9781528956079.jpg?1728326998135" alt="This image is the cover for the book Jacob's Wish"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jacob's Wish
      </h1>
      <p class="bookDescription body article font2">
        <p>Jacob’s Wish is a heartwarming tale of a small boy who carries a big secret with him wherever he goes. More often than not, he is jokingly mistaken for a little businessman on account of the rather large and obnoxious briefcase he refuses to leave behind. On a train ride to St Pancras station, Jacob meets a young girl named Abby and her uncle Eustace. After their rather awkward and playful introduction, Abby shares her love for philosophy and ‘demonstrates’ her skills in the art of deduction. Her bumptious behavior ultimately encourages Jacob to open up and divulge his own thoughts and ideas. Their shared experiences in dealing with life’s ups and downs quickly bonds the two, sparking an immediate friendship. Against all odds, they embark on a journey filled with danger and excitement, making plenty of new friends and running into old acquaintances along the way. You are invited to travel with Jacob, Abby and their companions as they make their way through the slithery underbelly of a secret and ancient organization known as The Sophic. Within the pages of this book, you will find a touching story about the power of friendship, the importance of trust and the resilience of the human spirit.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        S.M. Atlas
      </h2>
      
      <p class="authorDescription body article">TO THE READER: Since before I could remember, the imagined shaped every aspect of my life. From the toys that came alive when given a name and a voice, to the world around me that melted into something more than initially met the eye. Although not all living creatures could tell their stories, I found solace and deeper understanding when I witnessed their context and gave them a voice. This was not only where I had the best times, but the place that I have fought desperately to remain in throughout my life. In short, I have always feared the day when enchantment, wonder and mystery would suffer genocide. Only to be revisited by the occasional, short-lived nostalgic moment. Although flying dragons, monsters and other mythical beasts may forever exist in fantasy, let us do our very best in creating a compassionate, loving, and peaceful world. One that won’t merely be found in the fiction section of our local bookstores but littered between the pages of our lives.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?40a0b89d